import * as React from "react";
import Modal from "@mui/material/Modal";
import {
  ButtonWrapper,
  StyledBox,
  StyledBoxCard,
  StyledBoxCart,
  StyledBoxFlex,
  StyledBoxFlexGap,
  StyledBoxGap,
  StyledBoxImg,
  StyledTypography,
  StyledTypographyDes,
  StyledTypographyGroup,
} from "./style";
import CustomButton from "../../common/button/CustomButton";
import theme from "../../../theme";
import close from "../../../assets/images/x-close.png";
import groupMark from "../../../assets/images/group-mark.png";
import groupIcon from "../../../assets/images/group-cart.png";

import { Form, Formik } from "formik";
import Grid from "@mui/material/Grid2";
import CustomInput from "../../common/input/CustomInput";
import * as Yup from "yup";
import CustomDropdown from "../../common/common-dropdown/CustomDropdown";
import { arrOptionNumber } from "../about-product-self/constant";
import RadioButtonsGroup from "../../common/radio-button/CustomRadioButton";
import { options } from "./constant";
import {
  GROUP_CART_CREATE,
  GROUP_CART_LIST,
} from "../../../actions/group-cart-actions";
import { useDispatch, useSelector } from "react-redux";

export default function CreateGroup({
  open,
  handleClose,
  handleOpenProductDetails,
}) {
  const dispatch = useDispatch();
  const submitLock = React.useRef(false);
  const isLoading = useSelector((state) => state?.groupCartData?.isMeLoading);
  const formRef = React.useRef();

  React.useEffect(() => {
    if (!open) submitLock.current = false;
  }, [open]);

  const validationSchema = Yup.object({
    cart_name: Yup.string().required("Cart Name is required"),
    cart_timeline: Yup.number()
      .typeError("Cart Timeline must be a number")
      .required("Cart Timeline is required"),
    payment_options: Yup.string().required("Payment Option is required"),
  });

  return (
    <Modal open={open} onClose={handleClose}>
      <StyledBox>
        {/* Sticky Header */}
        <StyledBoxCard>
          <StyledBoxFlex>
            <img src={groupIcon} alt="groupIcon" loading="lazy" />
            <StyledTypography>Create a Group</StyledTypography>
          </StyledBoxFlex>
          <img
            src={close}
            alt="close"
            loading="lazy"
            onClick={handleClose}
            width={24}
            height={24}
            style={{ cursor: "pointer" }}
          />
        </StyledBoxCard>

        {/* Scrollable Content */}
        <Formik
          innerRef={formRef}
          initialValues={{
            cart_name: "",
            cart_timeline: "",
            payment_options: "",
          }}
          validationSchema={validationSchema}
          onSubmit={(values) => {
            if (submitLock.current || isLoading) return;
            submitLock.current = true;

            dispatch({
              type: GROUP_CART_CREATE,
              payload: values,
              onSuccess: () => {
                dispatch({ type: GROUP_CART_LIST, payload: { page: 1, limit: 10 } });
                handleClose();
              },
              onError: () => {
                submitLock.current = false;
              },
            });
          }}
        >
          {({
            errors,
            handleChange,
            handleBlur,
            values,
            touched,
            setFieldValue,
          }) => (
            <Form style={{ display: "flex", flexDirection: "column", flex: 1, overflow: "hidden" }}>
              <StyledBoxImg>
                <Grid container columnSpacing={2}>
                  <Grid size={{ lg: 12, md: 12, sm: 12, xs: 12 }}>
                    <CustomInput
                      color={theme.palette.custom.productTextColor}
                      fontSize={theme.typography.regular.fontSize}
                      height="10px"
                      required
                      placeholder="eg: Family cart"
                      customLabel="Cart Name"
                      name="cart_name"
                      value={values.cart_name}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={touched.cart_name && errors.cart_name}
                      helperText={touched.cart_name && errors.cart_name}
                    />
                  </Grid>
                  <Grid size={{ lg: 12, md: 12, sm: 12, xs: 12 }}>
                    <CustomDropdown
                      options={arrOptionNumber}
                      color={theme.palette.custom.productTextColor}
                      fontSize={theme.typography.regular.fontSize}
                      height="44px"
                      required
                      customLabel="Cart Timeline (in number of days)"
                      name="cart_timeline"
                      value={values.cart_timeline}
                      onBlur={handleBlur}
                      setFieldValue={setFieldValue}
                      error={touched.cart_timeline && Boolean(errors.cart_timeline)}
                      helperText={touched.cart_timeline && errors.cart_timeline}
                    />
                  </Grid>
                  <Grid size={{ lg: 12, md: 12, sm: 12, xs: 12 }}>
                    <RadioButtonsGroup
                      required
                      name="payment_options"
                      label="Payment Option"
                      options={options}
                      error={touched.payment_options && Boolean(errors.payment_options)}
                      helperText={touched.payment_options && errors.payment_options}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                  </Grid>
                </Grid>

                <StyledBoxGap>
                  <img
                    src={groupMark}
                    alt="groupMark"
                    loading="lazy"
                    style={{ width: "18px", height: "18px", cursor: "pointer" }}
                    onClick={handleOpenProductDetails}
                  />
                  <StyledTypographyGroup>Group Chat Guidelines</StyledTypographyGroup>
                </StyledBoxGap>

                <StyledBoxCart>
                  <StyledBoxFlexGap>
                    <img
                      src={groupMark}
                      alt="groupMark"
                      loading="lazy"
                      style={{ width: "18px", height: "18px" }}
                    />
                    <StyledTypographyGroup>Primary Cart Holder Notice</StyledTypographyGroup>
                  </StyledBoxFlexGap>
                  <StyledTypographyDes>
                    By creating a group cart, you become the main user. You&apos;ll be
                    responsible for inviting members and managing payment methods
                  </StyledTypographyDes>
                </StyledBoxCart>
              </StyledBoxImg>

              {/* Sticky Footer */}
              <ButtonWrapper>
                <CustomButton
                  padding="16px 50px"
                  btntype={"white"}
                  color={theme.palette.custom.virtualTitle}
                  border={"1px solid #D0D5DD"}
                  btnLabel="Decline"
                  onClick={handleClose}
                />
                <CustomButton
                  padding="16px 50px"
                  type="submit"
                  btntype={"primary"}
                  color={theme.palette.custom.white}
                  btnLabel="Accept"
                  disabled={isLoading}
                  isLoading={isLoading}
                />
              </ButtonWrapper>
            </Form>
          )}
        </Formik>
      </StyledBox>
    </Modal>
  );
}
